import React, { ReactElement, useEffect, useState } from 'react';
import { FETCH_PACKAGE, GUTTOR_SPACE, INVENTROY_CONSTANTS, PACKAGE_TYPE, PAGE_QUERY_PARAM } from '../../../../shared/constants/commonConstants';
import { FetchPackageRequest } from '../../../../shared/models/packageDetail.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { base64UrlDecode, base64UrlEncode, error, extractSecondLevelBaseUrl } from './../../../../utils/utility';
import HealthCheckPackageForm from './HealthCheckPackageForm';
import { FetchPackageResponse } from './../../../../shared/models/packageDetail.model';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { Button, Col, Row } from 'antd';
import { useLocation } from 'react-router-dom';

const EditHealthCheckPackage = ({ match: { path, params: { id: packageId } } }: any): ReactElement => {
  const pageNumber: any = new URLSearchParams(useLocation().search).get('page');
  const [healthCheckDetail, setHealthCheckDetail] = useState(null as any);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isFinalSubmit, setIsFinalSubmit] = useState(false);
  const id = base64UrlDecode(packageId);

  const fetchPackageDetail = async (
    payload: any,
  ): Promise<any> => {
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + FETCH_PACKAGE;
    const result: any = await SendRequest.instance.post<
      FetchPackageRequest,
      FetchPackageResponse
    >(url, payload);
    if (result && result.isSuccess && result.packages) {
      setHealthCheckDetail(result.packages[0]);
    } else {
      error('Please try again');
    }
  };

  useEffect((): void => {
    const reqpayload: FetchPackageRequest = {
      packageById: true,
      packageType: PACKAGE_TYPE.HEALTHCHECK,
      ids: [+id],
      fetchInActiveRecord: true,
    };
    fetchPackageDetail(reqpayload);
  }, [id]);

  const onFormSubmit = async (payload?: any): Promise<any> => {
    if (isSubmit) {
      setIsSubmit(false);
      setIsFinalSubmit(true);
    } else {
      setIsSubmit(true);
      setIsFinalSubmit(false);
    }
  };

  return (
    <div>
      <PageHeader
        colSize={18}
        backUrl={extractSecondLevelBaseUrl(path) +
          INVENTROY_CONSTANTS.hcPackageDetailRoute +
          base64UrlEncode(healthCheckDetail?.id) + PAGE_QUERY_PARAM + (pageNumber ? pageNumber : 1)}
        pageTitle={healthCheckDetail?.packageName}
        rightComponent={
          (): ReactElement =>
            <Row gutter={GUTTOR_SPACE}>
              <Col md={24}>
                <div className="text-right">
                  <Button className="btn-form-submit" type="link" onClick={onFormSubmit}> Submit
                  </Button>
                </div>
              </Col>
            </Row>}
      />
      <div className="ant-tabs-content-holder tab-custom-container">
        {healthCheckDetail && (
          <HealthCheckPackageForm hcData={healthCheckDetail}
            isSubmit={isSubmit}
            isFinalSubmit={isFinalSubmit} path={path} />
        )}
      </div>
    </div>
  );
};

export default EditHealthCheckPackage;
